import React from 'react'
import MostReviewSlider from '../components/AllSliders/MostReviewSlider'
import Gallery from '../components/Home component/Gallery'
import Header from '../components/Home component/Header'
import Howit from '../components/Home component/Howit'
import { Intro } from '../components/Home component/Intro'
import { Testim } from '../components/Home component/Testim'
 

const Home = () => {
  return ( 
    <>
        
        <Header/> 
        <Howit/> 
        <Gallery/> 
        <Intro/> 
        <MostReviewSlider/> 
        <Testim/> 
 
        
      </>
  )
}

export default Home